import RenderManager from "../rendering/render-manager";
import Utils from "../utils";
import * as Events from "../utils/events";
import EntranceExit from "./EntranceExit";
import Base2DElement from "./base-2d-element";

class Img {
    constructor(options = {}, comparer) {
        this.comparer = comparer;
        this._src = "";
        this.ratio = false;
        this.pictureCover = true;
        this._webp = Q3.browserCapabilities.supports.WebP;

        this.domElement = document.createElement("div");
        this.domElement.className = "q3-img-compare-item media-preloader";
        this.imageCnt = document.createElement("div");
        this.imageCnt.className = "q3-img-compare-image-cnt";
        this.imgEl = document.createElement("img");
        this.imageCnt.appendChild(this.imgEl);
        this.domElement.appendChild(this.imageCnt);
        if ("src" in options) {
            this.src = options.src;
        } else {
            this.imgEl.setAttribute("src", "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=");
        }
    }

    get webp() { return this._webp && this.extension !== "svg" && this.extension !== "webp" && this.extension !== "gif"; }
    set webp(val) { this._webp = val; }

    set src(val) {
        if (this._src !== val) {
            this._src = val;
            this.extension = val.split(".").pop();
            this.imgEl.setAttribute("src", `${Q3.s3Url}${val}${this.webp ? ".webp" : ""}`);
            this.updateRatio();
        }
    }

    get src() {
        return this._src ? `${Q3.s3Url}${this._src}${this.webp ? ".webp" : ""}` : "";
    }

    updateRatio() {
        if (!this.src) return;
        let tempImg = new Image();
        tempImg.onload = () => {
            this.ratio = tempImg.height / tempImg.width;
            this.redraw();
        };
        tempImg.src = this.src;
    }

    redraw(crop) {
        let {w, h} = this.comparer.calcSize();

        this.domElement.style.width = crop + "%";
        Object.assign(this.imageCnt.style, {
            width: w + 'px',
            height: h + 'px',
        });

        let imgSize;
        if (this.ratio === 1) {
            let side = Math.min(w, h);
            imgSize =  {
                width: side + "px",
                height: side + "px"
            }
        } else if (h > w * this.ratio) {
            imgSize = {
                width: w + "px",
                height: w * this.ratio + "px"
            }
        } else {
            imgSize = {
                width: h / this.ratio + "px",
                height: h + "px"
            }
        }
        if (!this.pictureCover) {
            Object.assign(this.imgEl.style, imgSize);
        } else {
            Object.assign(this.imgEl.style, {
                width: '100%',
                height: '100%',
                objectFit: 'cover'
            });
        }
    }
}

class ImgComparer extends Base2DElement {
    get type2d() { return "ImgComparer"; }

    get borderRadius() { return this._borderRadius; }
    set borderRadius(val) { this._borderRadius = val; }
    get borderColor() { return this._textBoxBorderColor; }
    set borderColor(val) { this._textBoxBorderColor = val; }
    get borderWidth() { return this._textBoxBorderWidth; }
    set borderWidth(val) { this._textBoxBorderWidth = val; }
    get border() {
        if (this.borderColor !== "transparent") {
            let c = new THREE.Color(this.borderColor);
            return `${this.borderWidth / 24}rem solid rgb(${c.r * 255},${c.g * 255}, ${c.b * 255})`
        } else { return `${this.borderWidth / 24}rem solid transparent`; }
    }

    _initDefaultVars() {
        super._initDefaultVars();
        this._wh = new THREE.Vector2(0.4, 0.35);
        this.backgroundColor = "rgba(0,0,0,0.1)";
        this._borderRadius = 25;
        this._borderColor = '#fff';
        this._borderWidth = 0;
    }

    _initValues(options) {
        console.log(1, options, "borderWidth" in options)
        this.backgroundColor = "backgroundColor" in options ? options.backgroundColor : this.backgroundColor;
        this._borderRadius = "borderRadius" in options ? options.borderRadius : this.borderRadius;
        this._borderColor = "borderColor" in options ? options.borderColor : this.borderColor;
        this._borderWidth = "borderWidth" in options ? options.borderWidth : this.borderWidth;
    }

    constructor(options, parentLayer, uuid) {

        super(options, parentLayer, uuid);

        this.imgComparerEl = document.createElement("div");
        this.domElement.appendChild(this.imgComparerEl);
        this.domElement.classList.add("q3-img-compare");
        this.domElement.style.backgroundColor = this.backgroundColor;
        this.domElement.style.borderRadius = parseFloat(this.borderRadius) / 15 + "rem";
        this.domElement.style.border = this.border;
        this.img1 = new Img(options.img1, this);
        this.img2 = new Img(options.img2, this);
        this.imgComparerEl.appendChild(this.img1.domElement);
        this.imgComparerEl.appendChild(this.img2.domElement);
        this.position = 50;
        this.resizing = false;
        this.resizer = this.createResizer();
        this.domElement.appendChild(this.resizer);
        if (Q3.isReady) {
            this.enterExitCtrl = new EntranceExit(this, [this.domElement]);
            this.enterExitCtrl.init(options);
        } else {
            Q3.Events.listen("tourReady", () => {
                this.enterExitCtrl = new EntranceExit(this, [this.domElement]);
                this.enterExitCtrl.init(options);
            })
        }



            this.domElement.addEventListener('click', e => {
                let rect = this.domElement.getBoundingClientRect();
                let w = rect.width;
                const x = rect.x;
                let position = Math.min(Math.max((e.clientX - x)/w*100, 0), 100);
                this.resizer.style.left = position + "%";
                this.position = position;
                this.redraw();

                this.selectHandler(e);
            }, false);

        this.redraw = this.redraw.bind(this);

        this.handleListeners(true);

        this.redraw();

    }

    createResizer() {
        const resizer = document.createElement("div");
        resizer.className = "img-compare-resizer";
        resizer.innerHTML = `<div class="resizer-thumb"></div>`;
        let position = this.position;
        resizer.style.left = position + "%";
        const onMouseMove = (event) => {
            let e = event.touches ? event.touches[0] : event;
            let rect = this.domElement.getBoundingClientRect();
            let w = rect.width;
            const x = rect.x;
            let position = Math.min(Math.max((e.clientX - x)/w*100, 0), 100);
            resizer.style.left = position + "%";
            this.position = position;
            this.redraw();
        };
        const onMouseUp = () => {
            window.removeEventListener("mousemove", onMouseMove);
            window.removeEventListener("touchmove", onMouseMove);
            window.removeEventListener("mouseup", onMouseUp);
            window.removeEventListener("touchend", onMouseUp);
            setTimeout(() => {
                this.resizing = false;
            }, 100)
        };
        const onMouseDown = () => {
            this.resizing = true;
            window.addEventListener("mousemove", onMouseMove);
            window.addEventListener("touchmove", onMouseMove);
            window.addEventListener("mouseup", onMouseUp);
            window.addEventListener("touchend", onMouseUp);
        };
        resizer.addEventListener("mousedown", onMouseDown);
        resizer.addEventListener("touchstart", onMouseDown);
        return resizer;
    }

    handleListeners(add) {
        Events[add ? "listen" : "unlisten"]("viewportchanged", this.redraw);
        Events[add ? "listen" : "unlisten"]("splashremoved", this.redraw);
    }

    playLeavingAnimation() {
        this.enterExitCtrl.playLeave();
    }

    cancelLeavingAnimation() {
        this.enterExitCtrl.cancelLeave();
    }

    render(width, height) {
        if (!Q3.data.layers.layers2D[this.parentLayer.uuid] || this.disabled || Utils.queryParams.has("disable_2d")) return;

        if (!this.isMounted || this.target) {
            this.redraw();
            if (width > 0 && height > 0) {
                this.isMounted = true;
            }
        }
    }

    calcSize() {

        let width = RenderManager.domElement.width / RenderManager.pixelRatio;
        let height = (RenderManager.domElement.height) / RenderManager.pixelRatio;

        if (!Q3.editMode && this.inLetterbox !== false) {
            width = Q3.letterbox.offsetWidth / RenderManager.pixelRatio;
            height = (Q3.letterbox.offsetHeight) / RenderManager.pixelRatio;
        }

        let w = this.width * width * RenderManager.pixelRatio;
        let h = this.height * height * RenderManager.pixelRatio;

        return {w, h, width, height}
    }

    redraw() {

        let currentSize = this.getVWSize();
        if (this[currentSize]) {
            Object.assign(this, this[currentSize]);
        }


        if (Q3.editMode) {
            if (Q3.mobileView && this.hiddenMobile) {
                this.domElement.style.opacity = 0.4;
            } else if (!Q3.mobileView && this.hiddenDesktop) {
                this.domElement.style.opacity = 0.4;
            } else {
                this.domElement.style.opacity = 1;
            }
        }

        let {w, h, width, height} = this.calcSize();
        let [x, y] = this._calcPosition(width, height);

        Object.assign(this.domElement.style, {
            width: w + 'px',
            height: h + 'px',
            top: y + "px",
            left: x + "px"
        });
        this.domElement.style.borderRadius = parseFloat(this.borderRadius) / 15 + "rem";
        this.domElement.style.backgroundColor = this.backgroundColor;
        this.domElement.style.border = this.border;
        this.img1.redraw(this.position);
        this.img2.redraw(100-this.position);
    }

    delete() {

        this.handleListeners(false);

        this.parentLayer.objects.splice(this.parentLayer.objects.indexOf(this), 1);
        this.parentLayer.domElement.removeChild(this.domElement);

        if (Q3.selected === this) {
            Q3.selected = null;
            Events.fire('selectchange');
        }

    }

    clone() {

    }

    hide() {

        this.pictureElement.classList.add('q3-picture-occluded');

    }

    show() {

        this.pictureElement.classList.remove('q3-picture-occluded');

    }

    setData(data) {

        let currentSize = this.getVWSize();
        Object.assign(this[currentSize], {
            x: data.x,
            y: data.y,
            width: data.width,
            height: data.height
        });

        this.data[currentSize] = {};

        Object.assign(this.data[currentSize], {
            x: data.x,
            y: data.y,
            width: data.width,
            height: data.height
        });

        this.redraw();

    }


}

export default ImgComparer;
export { ImgComparer };
